/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable camelcase */
/* eslint-disable no-bitwise */
import ReactHtmlParser from "react-html-parser";
import { parse } from "node-html-parser";
import getMLingualData from "MMT-UI/multiLingual";
import get from "lodash-es/get";
import date from "date-and-time";
// import { getCookie, setCookie } from 'cookies-next';
import {
  AIRLINE_TEMPLATE,
  API_PREFIX,
  AR_IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES,
  BASE_DOMAIN,
  BASE_URL_DOM_ABSOLUTE,
  BASE_URL_GI_DOM_ABSOLUTE,
  BASE_URL_INTL_ABSOLUTE,
  BLOCKS,
  CITY_AIRLINE_TEMPLATE,
  CURRENT_TEMPLATE,
  DATE,
  DATE_FORMAT_YYYYMMDD,
  DEST_CITY,
  DF_CITY_TEMPLATE,
  DF_FARE_CALENDAR_TEMPLATE,
  DF_OFFER_TEMPLATE,
  DF_ROUTE_AIRLINE_TEMPLATE,
  DF_ROUTE_TEMPLATE,
  FLIGHT_SCHEDULE_TEMPLATE,
  FLIGHTS_CB,
  FLIGHTS_CB_GLOBAL,
  FLIGHTS_CB_GOIBIBO,
  FLIGHTS_CB_SERVER,
  FLIGHTS_CB_SERVER_GLOBAL,
  FLIGHTS_CB_SERVER_GOIBIBO,
  HI_DF_OFFER_TEMPLATE,
  IF_CITY_AIRLINE_TEMPLATE,
  IF_CITY_CITY_TEMPLATE,
  IF_CITY_CITY_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_CITY_TEMPLATE,
  IF_CITY_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_COUNTRY,
  IF_DEST_CITY,
  IF_FARE_CALENDAR_TEMPLATE,
  IF_FARE_CALENDAR_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_FLIGHT_SCHEDULE_TEMPLATE,
  IF_FLIGHT_SCHEDULE_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_OFFER_TEMPLATE,
  IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_ROUTE_AIRLINE_TEMPLATE,
  IF_ROUTE_AIRLINE_TEMPLATE_UNITED_ARAB_EMIRATES,
  IF_SRC_CITY,
  IS_INTL,
  LANG,
  LANGUAGE,
  LANGUAGE_SUPPORT,
  GI_LANGUAGE_SUPPORT,
  MAPPING_API,
  REGION,
  SRC_CITY,
  STATIC_PAGES_TEMPLATE,
  TOKEN_AIRLINE_CHEAPEST_FARE_DATE,
  TOKEN_AIRLINE_CHEAPEST_PRICE,
  TOKEN_AIRLINE_CHEAPEST_ROUTE_DEST,
  TOKEN_AIRLINE_CHEAPEST_ROUTE_SRC,
  TOKEN_COUNTRY_FOLDER_CODE,
  TOKEN_CURRENCY_CODE,
  TOKEN_DES_CITY_CODE,
  TOKEN_DES_CITY_NAME,
  TOKEN_SRC_CITY_CODE,
  TOKEN_SRC_CITY_NAME,
  TOKENS,
  URL_ATTRIBUTE_COUNTRY,
  URL_CURRENT,
  URL_NEW_FLIGHT_CAB,
  USER_CURRENCY,
  BASE_URL_GI_INTL_ABSOLUTE,
  INTL_AIRLINE,
  AIRLINE,
} from "./Constants";
import { validateAndPopulate } from "../middleware/validator";
// import { fetchFares } from './apiHelper';
import { MONTHS_SHORT, WEEKDAYS_SHORT } from "./dayPickerLocale";
import { getFlightCabSyncHttpData, getSyncHttpData } from "./AsyncRestClient";
import { getCityByFlightCityCode } from "./dbUtils";
import {
  getDocumentFromDB as getDocumentFromMongoDB,
  getDocumentsFromDB as getDocumentsFromMongoDB,
  getAllDocumentsWithCountFromDB as getAllDocumentsWithCountFromMongoDB,
  getRandomDocumentsByCountFromDB as getRandomDocumentsByCountFromMongoDB,
  getRandomDocumentFromDB as getRandomDocumentFromMongoDB,
  getRegexMatchesFromDB as getRegexMatchesFromMongoDB,
  getDocumentsByPriorityFromDB as getDocumentsByPriorityFromMongoDB,
  getDocumentsOrderedByWeightFromDB as getDocumentsOrderedByWeightFromMongoDB,
  getDocumentByPriorityAirlineWithUnderscoreFromDB as getDocumentByPriorityAirlineWithUnderscoreFromMongoDB,
  getTopAirlineRoutesFromDB as getTopAirlineRoutesFromMongoDB,
  getTopAirlineDomesticRoutesFromDB as getTopAirlineDomesticRoutesFromMongoDB,
  getIfRoutesFromDB as getIfRoutesFromMongoDB,
  getFlightCitiesForMultipleCodeFromDB as getFlightCitiesForMultipleCodeFromMongoDB,
  getIntlCitiesForMultipleCodeFromDB as getIntlCitiesForMultipleCodeFromMongoDB,
  getIntlNonIndiaRoutesFromDB as getIntlNonIndiaRoutesFromMongoDB,
  getBlocksWithLinkTargetFromDB as getBlocksWithLinkTargetFromMongoDB,
} from "./mongoDbUtils";
import CacheMaster from "../caching/cacheMaster";
import { flightConfig } from "./flightConfig";
import { populateHeader } from "./FlightsUnificationCommonUtility";
import { tokenReplace } from "./Tokens";
import isbot from "isbot";
import redirection from "./redirection";
import { getGIAirlineByUrlPhrase, getGICityByFlightsUrlPhrase } from "./giDbUtils";

export function getCrId() {
  let d = new Date().getTime();
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    d += performance.now(); // use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const getDocumentFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    const document = await getDocumentFromMongoDB(collection, filter);
    return document;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getDocumentFromDB FETCH from DB :", err);
  }
  return null;
};

export const getDocumentsFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getDocumentsFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getDocumentsFromDB FETCH from DB :", err);
  }
  return null;
};

export const getAllDocumentsWithCountFromDB = async (collection, filter, count = 10) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getAllDocumentsWithCountFromMongoDB(collection, filter, count);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getAllDocumentsWithCountFromDB FETCH from DB :", err);
  }
  return null;
};

export const getRandomDocumentsByCountFromDB = async (collection, filter, count = 10) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getRandomDocumentsByCountFromMongoDB(collection, filter, count);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getRandomDocumentsByCountFromDB FETCH from DB :", err);
  }
  return null;
};

export const getRandomDocumentFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getRandomDocumentFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getRandomDocumentFromDB FETCH from DB :", err);
  }
  return null;
};

export const getRegexMatchesFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getRegexMatchesFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getRegexMatchesFromDB FETCH from DB :", err);
  }
  return null;
};

export const getDocumentsByPriorityFromDB = async (collection, filter, order, count) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getDocumentsByPriorityFromMongoDB(collection, filter, order, count);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getPriorityDocumentsFromDB FETCH from DB :", err);
  }
  return null;
};

export const getDocumentsOrderedByWeightFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getDocumentsOrderedByWeightFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getDocumentsOrderedByWeightFromDB FETCH from DB :", err);
  }
  return null;
};

export const getDocumentByPriorityAirlineWithUnderscoreFromDB = async (
  collection,
  count,
  filter,
) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getDocumentByPriorityAirlineWithUnderscoreFromMongoDB(collection, count, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getDocumentByPriorityAirlineWithUnderscoreFromDB FETCH from DB :", err);
  }
  return null;
};

export const getTopAirlineRoutesFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getTopAirlineRoutesFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getTopAirlineRoutesFromDB FETCH from DB :", err);
  }
  return null;
};

export const getTopAirlineDomesticRoutesFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getTopAirlineDomesticRoutesFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getTopAirlineDomesticRoutesFromDB FETCH from DB :", err);
  }
  return null;
};

export const getIfRoutesFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getIfRoutesFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getIfRoutesFromDB FETCH from DB :", err);
  }
  return null;
};

export const getFlightCitiesForMultipleCodeFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getFlightCitiesForMultipleCodeFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getFlightCitiesForMultipleCodeFromDB FETCH from DB :", err);
  }
  return null;
};

export const getIntlCitiesForMultipleCodeFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getIntlCitiesForMultipleCodeFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getIntlCitiesForMultipleCodeFromDB FETCH from DB :", err);
  }
  return null;
};

export const getIntlNonIndiaRoutesFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getIntlNonIndiaRoutesFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getIntlNonIndiaRoutesFromDB FETCH from DB :", err);
  }
  return null;
};

export const getBlocksWithLinkTargetFromDB = async (collection, filter) => {
  try {
    // Use direct MongoDB connection instead of API call
    return await getBlocksWithLinkTargetFromMongoDB(collection, filter);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("ERROR in getBlocksWithLinkTargetFromDB FETCH from DB :", err);
  }
  return null;
};

export const getAirportUrl = (airportUrlPhrase, aiportCityCode, cityUrlPhrase) =>
  `${BASE_URL_DOM_ABSOLUTE}${airportUrlPhrase}-${aiportCityCode}-${cityUrlPhrase}.html`;

export const getIntlAirportUrlCountryLanguage = (
  countryFolder,
  language,
  cityUrlPhrase,
  airportCode,
  airportUrlPhrase,
) => {
  return `${BASE_URL_INTL_ABSOLUTE}${
    countryFolder && countryFolder !== "" ? `${countryFolder}/` : ""
  }${
    language && language !== "" ? `${language}/` : ""
  }${cityUrlPhrase}-${airportCode}-${airportUrlPhrase}.html`;
};

export const getDisplayableName = (nameutil) => {
  const words = nameutil.split("_");
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  const resultString = capitalizedWords.join(" ");
  return resultString;
};

export const isMobile = (req) => {
  let userAgent;
  if (req) {
    userAgent = req["user-agent"];
  } else {
    userAgent = navigator.userAgent;
  }
  const isMobileBool = Boolean(
    userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i),
  );
  return isMobileBool;
};

export const checkForGoogleBot = (req, data) => {
  const dataMap = { ...data };
  let userAgent;
  if (req) {
    userAgent = req["user-agent"];
  } else {
    userAgent = navigator.userAgent;
  }
  if (userAgent.toLowerCase().includes("googlebot")) {
    dataMap.checkGoogleBot = true;
  }
  return dataMap;
};

export const getCurrencyForCountry = (dataMap) => {
  const { localeSettings } = dataMap;
  if (localeSettings?.currency) {
    return localeSettings?.currency === "INR" ? "₹" : localeSettings?.currency;
  }
  return "₹";
};

export const transformToHtml = (parentKey, path) => {
  if (path) {
    return ReactHtmlParser(get(parentKey, path));
  }
  return ReactHtmlParser(parentKey);
};

export const getRegexMatches = (str, reg) => {
  const matches = str.match(reg);
  if (matches) {
    matches.shift();
    return matches.filter((match) => !!match);
  }
  return [];
};

export const removeEmptyKeysFromObject = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj)
      .filter(([v]) => v != null)
      .map(([k, v]) => [k, v === Object(v) ? removeEmptyKeysFromObject(v) : v]),
  );

export function detectLang(str) {
  const text = str.replace(/\s/g);
  const langdic = {
    ara: /[\u0600-\u06FF]/,
    eng: /^[a-zA-Z0-9?><;,.[{}[\]\-_+=!@#$%^&*|']+$/,
    hin: /[\u0900-\u097F]/,
    tam: /[\u0b80-\u0bff][\u0bbe-\u0bcd\u0bd7]?/u,
  };
  let langKey;
  Object.entries(langdic).forEach(([key, value]) => {
    if (value.test(text)) {
      langKey = key;
    }
  });
  return langKey;
}

function padTwo(datePart) {
  if (datePart) {
    return `${`0${datePart}`}`.slice(-2);
  }
  return datePart;
}

// eslint-disable-next-line no-shadow
export function convertDate(date, isYearFirst) {
  if (!date) {
    return "";
  }
  const { SEPARATOR } = DATE;
  let modifiedDate = new Date(date);
  modifiedDate = modifiedDate.getMonth() + 1;
  if (isYearFirst) {
    return `${modifiedDate.getFullYear()}${SEPARATOR}${padTwo(
      modifiedDate.getMonth() + 1,
    )}${SEPARATOR}${padTwo(modifiedDate.getDate())}`;
  }
  return `${padTwo(modifiedDate.getDate())}${SEPARATOR}${padTwo(
    modifiedDate.getMonth() + 1,
  )}${SEPARATOR}${modifiedDate.getFullYear()}`;
}

export function getOneYearForwardDate() {
  const todayDate = new Date();
  return new Date(todayDate.getFullYear() + 1, todayDate.getMonth(), todayDate.getDate() - 1);
}

export function formateDate(dateObj, format, localeDateOpts = null, lang = null) {
  if (localeDateOpts) {
    return formatLocaleDate(dateObj, localeDateOpts, lang);
  }
  return date.format(dateObj, format);
}

function formatLocaleDate(dateObj, localeDateOpts, language = null) {
  const event = new Date(dateObj);
  const lang = language === null ? "eng" : language;
  const options = { weekday: "short", month: "short", day: "2-digit" };
  if (localeDateOpts?.withYear) {
    options.year = "numeric";
  }
  switch (lang) {
    case "ara": {
      return event.toLocaleDateString("ar", options);
    }
    case "hin": {
      return event.toLocaleDateString("hi", options);
    }
    default: {
      return event.toLocaleDateString("en", options);
    }
  }
}

export function getDateTimeDDMMYYY(dateUtil) {
  let day = dateUtil.getDate();
  let month = dateUtil.getMonth() + 1;
  const year = dateUtil.getFullYear();
  day = day < 10 ? `0${day}` : day;
  month = month < 10 ? `0${month}` : month;
  return `${day}-${month}-${year}`;
}

export function getFareCalendarUrl(src, dest) {
  return `${BASE_URL_DOM_ABSOLUTE}${src}-${dest}-fare-calendar.html`;
}

export function getFlightScheduleUrl(src, dest) {
  return `${BASE_URL_DOM_ABSOLUTE}${src}-${dest}-flight-schedule.html`;
}

export function getFlightScheduleUrlLanguage(lang, src, dest) {
  return `${BASE_URL_DOM_ABSOLUTE}${lang ? lang + "/" : ""}${src}-${dest}-flight-schedule.html`;
}

export function getFlightScheduleUrlCountryLanguage(lang, country, src, dest) {
  return `${BASE_URL_INTL_ABSOLUTE}${country && country !== "" ? `${country}/` : ""}${
    lang ? lang + "/" : ""
  }${src}-${dest}-flight-schedule.html`;
}

export function getSeoFlightUrl(src, dest, isIntl = false) {
  return isIntl
    ? `${BASE_URL_INTL_ABSOLUTE}${src}-${dest}-cheap-airtickets.html`
    : `${BASE_URL_DOM_ABSOLUTE}${src}-${dest}-cheap-airtickets.html`;
}

export function getGISeoFlightUrl(isIntl, src, dest, lang = null, country = null) {
  return `${isIntl ? BASE_URL_GI_INTL_ABSOLUTE : BASE_URL_GI_DOM_ABSOLUTE}${
    country ? `${country}/` : ""
  }${lang ? `${lang}/` : ""}${src}-to-${dest}-flights/`;
}

export function getGISeoFlightScheduleUrl(isIntl, src, dest, lang = null, country = null) {
  return `${isIntl ? BASE_URL_GI_INTL_ABSOLUTE : BASE_URL_GI_DOM_ABSOLUTE}${
    country ? `${country}/` : ""
  }${lang ? `${lang}/` : ""}${src}-to-${dest}-flight-schedule/`;
}

export const getRegionMapParams = (datamap = {}) => {
  const localeSettings = getRegionalData(datamap);
  return `&regionMap=${JSON.stringify(localeSettings)}`;
};

export const modifyTravelClassList = (travelClassList, labels) => {
  let modifiedTravelClassList = [];
  modifiedTravelClassList = travelClassList.map((item) => {
    if (labels[item.label]) {
      // eslint-disable-next-line no-param-reassign
      item.label = labels[item.label];
    }
    return item;
  });
  return modifiedTravelClassList;
};

export function getObjectFromValueInArray(arr, val, valueKey = "value") {
  let matchedObj = {};
  for (let i = 0; i < arr?.length; i += 1) {
    if (arr[i][valueKey] === val) {
      matchedObj = { ...arr[i], actualIndex: i };
      break;
    }
  }
  return matchedObj;
}

function getPaxUrlChunk({ numAdult, numChildren, numInfant, cabinClass }) {
  return `paxType=A-${numAdult}_C-${numChildren}_I-${numInfant}&cabinClass=${cabinClass}`;
}

export function formUrl(props) {
  const {
    fromCityCode,
    toCityCode,
    departDate,
    returnDate,
    tripType = "O",
    travelClassObj,
    lang = "eng",
    fareTypeObj,
  } = props;
  let funnelUrl = `search?tripType=${tripType}`;
  const deptDay = convertDate(departDate);
  const returnDay = convertDate(returnDate);
  const pft = fareTypeObj?.activePft ? fareTypeObj?.activePft : "";
  const retJouneyUrl = returnDay ? `_${fromCityCode}-${toCityCode}-${returnDay}` : "";
  funnelUrl = `${funnelUrl}&itinerary=${toCityCode}-${fromCityCode}-${deptDay}${retJouneyUrl}&${getPaxUrlChunk(
    travelClassObj,
  )}&sTime=${new Date().getTime()}&forwardFlowRequired=true&cmp=SEO&ccde=IN&lang=${lang}&pft=${pft}`;
  return `${funnelUrl}`;
}

export function seoFormUrl(props) {
  return `https://makemytrip.com/flight/${formUrl(props)}`;
}

export const formatValidDateFromDateStr = (str) => {
  // str = MM-DD-YYYY HH:mm:ss
  const timStr = str.split(/[^0-9]/);
  const arrTimStr = `${timStr[1]}/${timStr[2]}/${timStr[0]} ${timStr[3] ? timStr[3] : "00"}:${
    timStr[4] ? timStr[4] : "00"
  }`;
  return new Date(arrTimStr);
};

export const getServerSideData = async (data, context = {}) => {
  let dataMap = { ...data };
  const isDeviceMobile = isMobile(context?.req?.headers);
  dataMap.userAgent = context?.req?.headers?.["user-agent"] || "";
  dataMap = checkForGoogleBot(context?.req?.headers, dataMap);
  const redirectObject = await checkForCorrectUrl(
    context,
    dataMap?.isIntl,
    dataMap?.currentDomainName,
    dataMap?.isGoibibo,
  );
  if (redirectObject?.redirect) {
    dataMap.redirectObject = redirectObject;
    return dataMap;
  }

  const urlFragments = context?.params?.param;
  dataMap.current_url = urlFragments?.join("/") || "";
  dataMap.params = urlFragments || "";
  dataMap.cmp = context.query.cmp || "SEO";
  dataMap.ccde = "IN";
  dataMap.lang = "eng";
  const localeSettings = getRegionalData(context?.req);
  dataMap.localeSettings = localeSettings;
  dataMap.localeSettings.currency = localeSettings.currency || "INR";
  if (!dataMap?.localeSettings?.entityName) {
    delete dataMap.localeSettings.entityName;
  }
  const { language, region, userCurrency, isGoibibo = false, dvid } = localeSettings || {};
  dataMap.dvid = dvid;
  dataMap[USER_CURRENCY] = userCurrency || "INR";
  dataMap.isDeviceMobile = isDeviceMobile;
  const LANGAGE_SUPPORT_ENUM = isGoibibo ? GI_LANGUAGE_SUPPORT : LANGUAGE_SUPPORT;
  if (urlFragments?.length === 2) {
    if (LANGAGE_SUPPORT_ENUM[language]) {
      dataMap.lang = LANGAGE_SUPPORT_ENUM[language];
      dataMap.language = language;
    } else {
      dataMap.ccde = region;
      [dataMap.country_folder] = urlFragments;
      dataMap[TOKEN_COUNTRY_FOLDER_CODE] = region;
      dataMap[TOKEN_CURRENCY_CODE] = userCurrency;
      [dataMap[URL_ATTRIBUTE_COUNTRY]] = urlFragments;
    }
  } else if (urlFragments?.length === 3) {
    dataMap.ccde = region;
    [dataMap.country_folder] = urlFragments;
    dataMap[TOKEN_COUNTRY_FOLDER_CODE] = region;
    dataMap[TOKEN_CURRENCY_CODE] = userCurrency;
    [dataMap[URL_ATTRIBUTE_COUNTRY]] = urlFragments;
    if (LANGAGE_SUPPORT_ENUM[language]) {
      dataMap.lang = LANGAGE_SUPPORT_ENUM[language];
      dataMap.language = language;
    }
  }
  dataMap.ccde = region;
  dataMap = await validateAndPopulate(dataMap);
  dataMap = await getLangaugeData(dataMap);
  const propObject = {
    country: region,
    language: LANGUAGE_SUPPORT[language],
    currency: userCurrency || "INR",
  };
  const response = await fetchHeaderConfig(propObject);
  dataMap.globalConfig = response || {};
  return dataMap;
};
// eslint-disable-next-line no-unused-vars
// export const getFareWeekdata = async (dataMap, context = {}) => {
//   dataMap.akakaka = 'NOOOO';
//   // eslint-disable-next-line no-unused-vars
//   const response = await fetchFares(
//     dataMap?.tokens?.src_city_code,
//     dataMap?.tokens?.dest_city_code,
//     dataMap?.ccde,
//     dataMap?.lang,
//     'IN',
//   );
// };

export const fetchHeaderConfig = async ({
  country,
  currency,
  language,
  entity,
  profile,
  vendor,
  isLoggedIn,
} = {}) => {
  const domain = "http://mapi.mmt.mmt";
  const url = new URL(`${domain}/pwa/hlp/v3/api/get-header-config`);

  // Conditionally append query parameters only if they are defined
  if (country) url.searchParams.append("country", country);
  if (currency) url.searchParams.append("currency", currency);
  if (language) url.searchParams.append("language", language);
  if (entity) url.searchParams.append("entity", entity);
  if (profile) url.searchParams.append("profile", profile);
  if (vendor) url.searchParams.append("vendor", vendor);
  if (isLoggedIn) url.searchParams.append("isLoggedIn", isLoggedIn);
  const response = await getSyncHttpData(url.toString(), null, "GET", null);
  return response?.result;
};

export const getBackgroundImage = (image) => {
  if (!image) return {};
  return {
    backgroundImage: `url(${image})`,
  };
};

export const getTemplateFilterFromTemplateType = (dataMap, templateType, params) => {
  switch (templateType) {
    case STATIC_PAGES_TEMPLATE:
      return {
        url: params.join("/"),
        lob_type: dataMap?.isIntl ? "international_flights" : "flights",
      };
    case DF_OFFER_TEMPLATE:
      return {
        template_type: "df_offer_template",
      };
    case HI_DF_OFFER_TEMPLATE:
      return {
        template_type: "hi_df_offer_template",
      };
    case AR_IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "ar_if_offer_template_united_arab_emirates",
      };
    case IF_OFFER_TEMPLATE:
      return {
        template_type: "if_offer_template",
      };
    case IF_OFFER_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_offer_template_united_arab_emirates",
      };
    case DF_CITY_TEMPLATE:
      return {
        template_type: "df_city_template",
      };
    case IF_CITY_TEMPLATE:
      return {
        template_type: "if_city_template",
      };
    case IF_CITY_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_city_template_united_arab_emirates",
      };
    case CITY_AIRLINE_TEMPLATE:
      return {
        template_type: "city_airline_template",
      };
    case IF_CITY_AIRLINE_TEMPLATE:
      return {
        template_type: "if_city_airline_template",
      };
    case DF_ROUTE_TEMPLATE:
      return {
        template_type: "df_route_template",
      };
    case IF_CITY_CITY_TEMPLATE:
      return {
        template_type: "if_city_city_template",
      };
    case IF_CITY_CITY_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_city_city_template",
      };
    case DF_ROUTE_AIRLINE_TEMPLATE:
      return {
        template_type: "df_route_airline_template",
      };
    case IF_ROUTE_AIRLINE_TEMPLATE:
      return {
        template_type: "if_route_airline_template",
      };
    case IF_ROUTE_AIRLINE_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_route_airline_template_united_arab_emirates",
      };
    case DF_FARE_CALENDAR_TEMPLATE:
      return {
        template_type: "df_fare_calendar_template",
      };
    case IF_FARE_CALENDAR_TEMPLATE:
      return {
        template_type: "if_fare_calendar_template",
      };
    case IF_FARE_CALENDAR_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_fare_calendar_template_united_arab_emirates",
      };
    case FLIGHT_SCHEDULE_TEMPLATE:
      return {
        template_type: "flight_schedule_template",
      };
    case IF_FLIGHT_SCHEDULE_TEMPLATE:
      return {
        template_type: "if_flight_schedule_template",
      };
    case IF_FLIGHT_SCHEDULE_TEMPLATE_UNITED_ARAB_EMIRATES:
      return {
        template_type: "if_flight_schedule_template_united_arab_emirates",
      };
    // case
    default:
      return {};
  }
};

export function getRandomNumeric(length) {
  let result = "";
  const numericString = "0123456789";
  for (let i = 0; i < length; i += 1) {
    const index = Math.floor(Math.random() * 10);
    result += numericString[index];
  }
  return result;
}

export function getDate(format, addDays) {
  let dateUtil = new Date();
  dateUtil.setDate(dateUtil.getDate() + addDays);
  dateUtil = date.format(dateUtil, format);
  return `${dateUtil}`;
}

export function convertDateFormat(dateInput, currentFormat, requiredFormat) {
  const dateUtil = date.parse(dateInput, currentFormat);
  return `${date.format(dateUtil, requiredFormat)}`;
}

export function convertDateToString(dateInput, requiredFormat) {
  return `${date.format(dateInput, requiredFormat)}`;
}

export const fareFinderBreadCrumb = (data) => {
  const { breadcrumb } = data;
  let breadcrumbHTML = "";
  Object.keys(breadcrumb).forEach((key) => {
    if (breadcrumb[key]) {
      breadcrumbHTML = `${breadcrumbHTML}<li class="active"><a href="${breadcrumb[key]}"><span>${key}</span></a></li>`;
    } else {
      breadcrumbHTML = `${breadcrumbHTML}<li class="active"><span>${key}</span></li>`;
    }
  });
  return breadcrumbHTML;
};

export const changeEnglishToHindi = (args) => {
  let showingDate = args;
  const daysInShort = WEEKDAYS_SHORT.hin;
  const monthsInShort = MONTHS_SHORT.hin;

  const days = WEEKDAYS_SHORT.eng;
  const months = MONTHS_SHORT.eng;

  let day = "";
  let month = "";
  let dayFound = 0;
  let monthFound = "";

  let dateParts = showingDate.split(" ");
  // eslint-disable-next-line no-unused-vars
  dateParts = dateParts.map((element) => {
    element = element.replaceAll(",", "");
    if (isAlpha(element)) {
      if (dayFound === 0) {
        day = element;
        dayFound = 1;
      } else if (dayFound === 1) {
        month = element;
        monthFound = 1;
      }
    }
    return element;
  });

  let dayIndex = 0;
  let monthIndex = 0;

  let temp = "";

  if (dayFound === 1) {
    dayIndex = checkIndex(day, days);
    if (dayIndex === -1) {
      if (monthFound === 1) {
        temp = day;
        day = month;
        month = temp;
        dayIndex = checkIndex(day, days);
        showingDate = showingDate.replace(day, daysInShort[dayIndex]);
      } else if (monthFound === 0) {
        dayIndex = checkIndex(day, months);
        showingDate = showingDate.replace(day, monthsInShort[dayIndex]);
      }
    } else {
      showingDate = showingDate.replace(day, daysInShort[dayIndex]);
    }
  }

  if (monthFound === 1) {
    monthIndex = checkIndex(month, months);
    showingDate = showingDate.replace(month, monthsInShort[monthIndex]);
  }
  return showingDate;
};

export const isAlpha = (str) => str.match("[a-zA-Z]+");

const checkIndex = (dayMonths, dayMonthsArray) => {
  let index = -1;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < dayMonthsArray.length; i++) {
    if (dayMonths.toLowerCase().includes(dayMonthsArray[i].toLowerCase())) {
      index = i;
      break;
    }
  }
  return index;
};

export const toRad = (Value) => (Value * Math.PI) / 180;

export const getAerialDistanceFromLatLong = (srcLat, srcLon, destLat, destLon) => {
  if (srcLat && srcLon && destLat && destLon) {
    const earthRadius = 3958.75;
    const dLat = toRad(destLat - srcLat);
    const dLng = toRad(destLon - srcLon);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(srcLat)) * Math.cos(toRad(destLat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const dist = earthRadius * c;

    const meterConversion = 1609;
    return Math.round((dist * meterConversion) / 1000);
  }
  return null;
};
// eslint-disable-next-line no-unused-vars
export const getDistanceFromLatLong = async (srcLat, srcLon, destLat, destLon) => {
  // try {
  // eslint-disable-next-line no-unused-vars
  const keyString = "AIzaSyDJVptFz1tixKumpBrEvgmnAhNpJQdtrSI";

  // const distanceResponseMap = await (await fetch(`https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=${
  //   srcLat},${srcLon}&destinations=${destLat},${destLon}&key=${keyString}`)).json();

  //   if(distanceResponseMap.status && distanceResponseMap.rows
  // 				&& distanceResponseMap.status.toLowerCase() === 'ok')
  // 		{
  // 			List resultRows = (List) distanceResponseMap.get("rows");
  // 			if(resultRows.size() >= 1)
  // 			{
  // 				List distanceElements = (List) ((Map) resultRows.get(0)).get("elements");
  // 				if(distanceElements.size() >= 1)
  // 				{
  // 					Map distanceData = (Map) distanceElements.get(0);
  // 					if(distanceData.containsKey("status")
  // 							&& distanceData.get("status").toString().equalsIgnoreCase("OK")
  // 							&& distanceData.containsKey("distance"))
  // 					{
  // 						Map distance = (Map) distanceData.get("distance");
  // 						return Integer.toString(((Double) distance.get("value")).intValue());
  // 					}
  // 				}
  // 			}
  // 		}}
  //     catch (error) {
  //        console.error("errorGetDistanceFromLatLongCommon", error);
  //     }
  //     return null;
  return "";
};

export const isAirlineTemplate = (data) => {
  const dataMap = { ...data };
  let isAirline = false;
  if (dataMap[CURRENT_TEMPLATE]) {
    const template = dataMap[CURRENT_TEMPLATE];
    isAirline = template.includes(AIRLINE_TEMPLATE);
  }
  return isAirline;
};

export async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 10000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);

  return response.json();
}

export const getThisBlock = (data, blockDelta) => {
  let block = null;
  let allBlocks = null;
  const dataMap = { ...data };
  try {
    allBlocks = dataMap[BLOCKS];
    if (allBlocks) {
      for (let i = 0; i < allBlocks.length; i += 1) {
        if (allBlocks[i].delta === blockDelta) {
          block = allBlocks[i];
          break;
        }
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("errorGetThisBlock Catch", error);
  }
  return block;
};

export const shuffle = (array) => {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const getDistanceUrl = (srcUrlPhrase, destUrlPhrase) =>
  `${BASE_URL_DOM_ABSOLUTE}${srcUrlPhrase}-${destUrlPhrase}-distance.html`;

export const getDistanceUrlLanguage = (language, srcUrlPhrase, destUrlPhrase) =>
  `${BASE_URL_DOM_ABSOLUTE}${
    language && language !== "" ? `${language}/` : ""
  }${srcUrlPhrase}-${destUrlPhrase}-distance.html`;

export const getFlightWebCheckInUrl = (airline) =>
  `${BASE_URL_DOM_ABSOLUTE}${airline}-web-check-in.html`;

export const getSchdeuleUrlFlights = (airline) =>
  `${BASE_URL_DOM_ABSOLUTE}${airline}-airlines-flight-schedule.html`;

export const getFlightBaggageUrl = (airline) =>
  `${BASE_URL_DOM_ABSOLUTE}${airline}-baggage-allowance.html`;

export const getHindiSchdeuleUrlFlights = (airline) =>
  `${BASE_URL_DOM_ABSOLUTE}hi/${airline}-airlines-flight-schedule.html`;

export const getIntlFlightWebCheckInUrl = (airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${airline}-web-check-in.htm`;

export const getIntlFlightScheduleUrl = (airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${airline}-flight-schedule.htm`;

export const getIntlFlightBaggageUrl = (airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${airline}-baggage-allowance.htm`;

export const getAirlineUrl = (country, language, airlineUrlPhrase) =>
  `${BASE_URL_INTL_ABSOLUTE}${country && country !== "" ? `${country}/` : ""}${
    language && language !== "" ? `${language}/` : ""
  }${airlineUrlPhrase}-airlines.html`;

export const getSeoFlightUrlLanguage = (language, src, dest) =>
  `${BASE_URL_DOM_ABSOLUTE}${
    language && language !== "" ? `${language}/` : ""
  }${src}-${dest}-cheap-airtickets.html`;

export const getAirlineUrlPhrase = (airlineUrlPhrase) =>
  `${BASE_URL_DOM_ABSOLUTE}${airlineUrlPhrase}-airlines.html`;

export const getCityAirlineUrl = (city, airlineUrlPhrase) =>
  `${BASE_URL_DOM_ABSOLUTE}${city}-${airlineUrlPhrase}-flights.html`;

export const getCityTicketsUrl = (city) => `${BASE_URL_INTL_ABSOLUTE}${city}-flight-tickets.html`;

export const getFlightInformationSystemUrl = (airlineCode) =>
  `${BASE_URL_DOM_ABSOLUTE}sitemap-flights-flight_information_system-${airlineCode}-index-new.xml`;

export const getCityTicketsUrlCountryLanguage = (countryFolder, language, city) =>
  `${BASE_URL_INTL_ABSOLUTE}${countryFolder && countryFolder !== "" ? `${countryFolder}/` : ""}${
    language && language !== "" ? `${language}/` : ""
  }${city}-flight-tickets.html`;

export const getInternationalRouteAirlineUrl = (src, dest, airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${src}-${dest}-${airline}-tickets.html`;

export const getSeoFlightUrlCountryFolder = (country, src, dest) =>
  `${BASE_URL_INTL_ABSOLUTE}${
    country && country !== "" ? `${country}/` : ""
  }${src}-${dest}-cheap-airtickets.html`;

export const getFareCalendarUrlCountry = (country, src, dest) =>
  `${BASE_URL_INTL_ABSOLUTE}${
    country && country !== "" ? `${country}/` : ""
  }${src}-${dest}-fare-calendar.html`;

export const getFareCalendarUrlLanguage = (language, src, dest) => {
  return `${BASE_URL_INTL_ABSOLUTE}${
    language && language !== "" ? `${language}/` : ""
  }${src}-${dest}-fare-calendar.html`;
};

export const getFareCalendarUrlCountryLanguage = (countryFolder, language, src, dest) => {
  return `${BASE_URL_INTL_ABSOLUTE}${
    countryFolder && countryFolder !== "" ? `${countryFolder}/` : ""
  }${language && language !== "" ? `${language}/` : ""}${src}-${dest}-fare-calendar.html`;
};

export const getRouteAirlineUrl = (isIntl, country, src, dest, airline) =>
  `${isIntl ? BASE_URL_INTL_ABSOLUTE : BASE_URL_DOM_ABSOLUTE}${
    country && country !== "" ? `${country}/` : ""
  }${src}-${dest}-${airline}-tickets.html`;

export const getRouteAirlineUrlGI = (isIntl, country, src, dest, airline) =>
  `${isIntl ? BASE_URL_INTL_ABSOLUTE : BASE_URL_DOM_ABSOLUTE}${
    country && country !== "" ? `${country}/` : ""
  }${src}-${dest}-${airline}-airline-schedule/`;

export const getRouteAirlineUrlCountryLanguage = (countryFolder, language, src, dest, airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${!countryFolder || countryFolder === "" ? "" : `${countryFolder}/`}${
    !language || language === "" ? "" : `${language}/`
  }${src}-${dest}-${airline}-tickets.html`;

export const getHindiRouteAirlineUrl = (src, dest, airline) =>
  `${BASE_URL_DOM_ABSOLUTE}hi/${src}-${dest}-${airline}-tickets.html`;

export const getIntlUrlCountryCity = (data) => {
  const dataMap = { ...data };
  const country = dataMap[IF_COUNTRY];
  let sourceDomesticCity = dataMap[IF_SRC_CITY];
  const destCity = dataMap[IF_DEST_CITY];
  if (destCity && country.code === destCity.country_id) {
    sourceDomesticCity = destCity;
  }

  return sourceDomesticCity;
};

export const getIntlRouteAirlineUrl = (isIntl, src, dest, countryFolder, language, airline) =>
  `${isIntl ? BASE_URL_INTL_ABSOLUTE : BASE_URL_DOM_ABSOLUTE}${
    !countryFolder || countryFolder === "" ? "" : `${countryFolder}/`
  }${!language || language === "" ? "" : `${language}/`}${src}-${dest}-${airline}-tickets.html`;

export const getSeoFlightUrlCountryLanguage = (countryFolder, language, src, dest) =>
  `${BASE_URL_INTL_ABSOLUTE}${!countryFolder || countryFolder === "" ? "" : `${countryFolder}/`}${
    !language || language === "" ? "" : `${language}/`
  }${src}-${dest}-cheap-airtickets.html`;

export const getRouteAirlineUrlCountry = (countryFolder, src, dest, airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${
    !countryFolder || countryFolder === "" ? "" : `${countryFolder}/`
  }${src}-${dest}-${airline}-tickets.html`;

export const getIntlCityAirlineUrl = (city, airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${city}-${airline}-tickets.html`;

export const getIntlCityAirlineUrlCountryLanguage = (countryFolder, language, city, airline) =>
  `${BASE_URL_INTL_ABSOLUTE}${!countryFolder || countryFolder === "" ? "" : `${countryFolder}/`}${
    !language || language === "" ? "" : `${language}/`
  }${city}-${airline}-tickets.html`;

export const getIntlCityAirlineRedirectUrl = (city, airline) =>
  `international-flights/${city}-${airline}-tickets.html`;

export const getIntlAirlinesPageRedirectUrl = () => "international-flights/airlines.html";

export const getAirlinesPageRedirectUrl = () => "flights/airlines.html";

export const getCityTicketsRedirectUrl = (city) => `flights/${city}-flight-tickets.html`;

export const getAirlineRedirectUrl = (airlineUrlPhrase) =>
  `flights/${airlineUrlPhrase}-airlines.html`;

export const getIntlAirlineRedirectUrl = (airlineUrlPhrase) =>
  `international-flights/${airlineUrlPhrase}-airlines.html`;

export const replaceDomainName = (currentDomain, inputString) => {
  const replaceDomain = currentDomain !== BASE_DOMAIN;
  if (!inputString || !replaceDomain) return inputString;
  let finalString = inputString;
  finalString = inputString.replaceAll("www.makemytrip.com", currentDomain);
  finalString = finalString.replaceAll("/makemytrip.com", currentDomain);
  return finalString;
};

export const getLangaugeData = async (data) => {
  const dataMap = { ...data };
  const { lang, isDeviceMobile } = dataMap;
  const polyglotTags = {
    dt: ["MMT_FLIGHTS_UI_DT"],
    pwa: ["MMT_FLIGHTS_UI_PWA"],
  };
  try {
    const response = await getMLingualData({
      lan: lang,
      tags: !isDeviceMobile ? polyglotTags.dt : polyglotTags.pwa,
      flat: isDeviceMobile,
      flatArray: false,
    });
    dataMap.multiLingualData = response.header || {};
  } catch (error) {
    // eslint-disable-next-line no-console
    dataMap.multiLingualData = {};
    console.error("errorGettingLanguageDataUsingDefault", error);
  }
  return dataMap;
};

export function getRegionalData(req) {
  if (req && req.localeSettings) {
    return req.localeSettings;
  }
  if (typeof window !== "undefined" && window.localeSettings) {
    return window.localeSettings;
  }
  if (typeof global !== "undefined" && global.localeSettings) {
    // Add a pdt log if this is triggering
    return global.localeSettings;
  }
  return {};
}

export function isGlobalFlow(requestObj) {
  const localeSettings = getRegionalData(requestObj);
  return (localeSettings?.isGlobalFlagEnabled && localeSettings?.entityName === "global") || false;
}

export function isGoibiboFlow(requestObj) {
  const localeSettings = getRegionalData(requestObj);
  return !!localeSettings?.isGoibibo;
}

export const getRegionMap = (type, requestObj) => {
  const localeSettings = getRegionalData(requestObj);
  const isWW =
    typeof localeSettings?.isWorldwide !== "undefined"
      ? parseInt(localeSettings?.isWorldwide, 10)
      : 0;
  const generalRegionObj = {
    region: localeSettings?.region?.toLowerCase() || "in",
    currency: localeSettings?.currency || "inr",
    language: localeSettings?.language || "eng",
  };
  if (type === "headers") {
    if (localeSettings?.isGlobalFlagEnabled) {
      return {
        ...generalRegionObj,
        "entity-name": localeSettings?.entityName,
        "user-country": isWW ? localeSettings?.userCountry : localeSettings?.region,
        "User-Currency": localeSettings?.userCurrency,
      };
    }
    return {
      ...generalRegionObj,
      "User-Currency": localeSettings?.userCurrency,
    };
  }
  return generalRegionObj;
};

const fetchFlightCab = async (isSrcCity, cityData, src, dest, data) => {
  const cityName = cityData.name;
  const cityCode = cityData.flight_city_code;
  try {
    const fcUrl = getFinalUrl(
      `${FLIGHTS_CB}/api/flights-search/autosuggest?matchCity=true&limit=5&region=in&currency=inr&language=eng&query=${cityName}`,
      data,
    );
    const respJson = await getFlightCabSyncHttpData(fcUrl, null, "GET", null, data);
    const desResult = respJson.results;
    const desSuggest = desResult.SUGGESTIONS;
    const desData = desSuggest.data;
    let nearByCityIata = "";
    let nearByCity = null;
    for (let i = 0; i < desData?.length; i += 1) {
      const elements = desData[i];
      if (elements.iata.toLowerCase() === `"${cityCode.toLowerCase()}"`) {
        return "";
      }
    }
    let nearByCityPromise = [];
    for (let j = 0; j < desData?.length; j += 1) {
      const currCityCode = desData[j].iata.replaceAll('/^"|"$/', "");
      if (isSrcCity) {
        if (currCityCode.toLowerCase() === src.toLowerCase()) {
          return "";
        }
      } else {
        if (currCityCode.toLowerCase() === dest.toLowerCase()) {
          return "";
        }
      }
      nearByCityIata = desData[j].iata.replaceAll('/^"|"$/', "");
      nearByCityPromise.push(getCityByFlightCityCode(nearByCityIata));
    }
    await Promise.allSettled(nearByCityPromise)
      .then((results) => {
        // Create a new object with keys and their respective data or errors
        nearByCityPromise = results;
      })
      .catch((error) => {
        console.error("errorSetFlightCabData:", error);
      });
    for (let cityIdx = 0; cityIdx < nearByCityPromise?.length; cityIdx += 1) {
      if (nearByCityPromise[cityIdx].status === "fulfilled" && nearByCityPromise[cityIdx].value) {
        nearByCity = nearByCityPromise[cityIdx].value;
        break;
      }
    }
    const nearByUrl = nearByCity.flights_url_phrase;
    return nearByUrl;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("errorFetchFlightCab", error);
  }
  return "";
};

export const setFlightCabData = async (isSrcCity, data) => {
  const dataMap = { ...data };
  let cityCode = "";
  const srcCity = dataMap[SRC_CITY];
  const destCity = dataMap[DEST_CITY];
  try {
    const city = isSrcCity ? srcCity : destCity;
    if (city && !city.airport_flag) {
      cityCode = await fetchFlightCab(
        isSrcCity,
        city,
        srcCity.flight_city_code,
        destCity.flight_city_code,
        dataMap,
      );
      if (cityCode === "") return ["", dataMap];

      const currentUrl = dataMap[URL_NEW_FLIGHT_CAB]
        ? dataMap[URL_NEW_FLIGHT_CAB]
        : dataMap[URL_CURRENT];
      //                    String nearByUrl = cityCode;
      const currentCityUrlPhrase = city.flights_url_phrase;
      const finalUrl = currentUrl.replace(currentCityUrlPhrase, cityCode);
      dataMap[URL_NEW_FLIGHT_CAB] = finalUrl;
      return [cityCode, dataMap];
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("errorSetFlightCabData", error);
  }
  return [cityCode, dataMap];
};

export const getEntityType = (domain) => {
  if (domain.indexOf("makemytrip.com") > -1) {
    return "IN";
  }
  if (domain.indexOf("ae.makemytrip.global") > -1) {
    return "AE";
  }
  if (domain.indexOf("sa.makemytrip.global") > -1) {
    return "SA";
  }
  if (domain.indexOf("makemytrip.global") > -1) {
    return "GLOBAL";
  }
  return "IN";
};

export const getCountryCurrencyMap = async (country) => {
  try {
    let map = await CacheMaster.getCache("countryCurrencyMap");
    if (!map) {
      const body = JSON.stringify({
        requestMap: {
          COUNTRYLIST: {},
        },
      });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const response = await fetchWithTimeout(MAPPING_API, {
        method: "POST",
        body,
        headers: myHeaders,
      });
      map = response?.response?.COUNTRYLIST?.data;
      if (map) {
        await CacheMaster.setCache("countryCurrencyMap", map, 4 * 24 * 60 * 60);
        return map;
      } else {
        return [];
      }
    } else {
      return map;
    }
  } catch (error) {
    console.error("Error in getCountryCurrencyMap", error);
  }
  return [];
};

export const getFinalUrl = (url, dataMap) => {
  const isFlowGlobal = isGlobalFlow(dataMap);
  const isFlowGoibibo = isGoibiboFlow(dataMap);
  if (isFlowGlobal) {
    url = url.replace(FLIGHTS_CB_SERVER, FLIGHTS_CB_SERVER_GLOBAL);
    url = url.replace(FLIGHTS_CB, FLIGHTS_CB_GLOBAL);
  } else if (isFlowGoibibo) {
    url = url.replace(FLIGHTS_CB_SERVER, FLIGHTS_CB_SERVER_GOIBIBO);
    url = url.replace(FLIGHTS_CB, FLIGHTS_CB_GOIBIBO);
  }
  return url;
};

export const getFareCalendarApiAndHeader = (data, key) => {
  const dataMap = { ...data };
  const { apiConfig } = flightConfig;
  let headersMap = {};
  headersMap = populateHeader(dataMap, headersMap);
  dataMap.tokens.crId = getCrId();
  dataMap.tokens[DATE_FORMAT_YYYYMMDD] = getDate("YYYYMMDD", 0);
  const tempObject = {};
  tempObject[DATE_FORMAT_YYYYMMDD] = dataMap.tokens[DATE_FORMAT_YYYYMMDD];
  tempObject.crId = dataMap.tokens.crId;
  if (key) {
    tempObject.src_city_code = key.split("-")[0];
    tempObject.dest_city_code = key.split("-")[1];
  } else {
    tempObject.src_city_code = dataMap.tokens.src_city_code;
    tempObject.dest_city_code = dataMap.tokens.dest_city_code;
  }
  let apiUrl = getFinalUrl(tokenReplace(apiConfig.fareCalendarCB, tempObject), dataMap);
  const regionalData = getRegionalData(dataMap);
  apiUrl += `&region=${regionalData.region}&currency=${regionalData.userCurrency}&language=${regionalData.language}&cmp=FLIGHTS_SEO&template=${dataMap[CURRENT_TEMPLATE]}`;
  const options = {
    method: "GET",
    headers: headersMap,
    credentials: "include",
  };
  return { apiUrl, options, dataMap };
};

// Constants for cache configuration
const FARE_CACHE_TTL_SECONDS = 18 * 60 * 60; // 18 hours
const NO_DATA_ERROR = { error: "No Data Found" };

// Global settings defaults
const GLOBAL_SETTINGS_DEFAULTS = {
  isGlobalFlagEnabled: true,
  entityName: "global",
  region: "AE",
  currency: "AED",
};

/**
 * Applies global or forced currency settings to the data map
 * @param {Object} data - Original data map
 * @param {Object} options - Options containing useGlobalSettings and forceCurrency
 * @returns {Object} Modified data map with applied settings
 */
const applyLocaleOverrides = (data, options = {}) => {
  const { useGlobalSettings = false, forceCurrency = null } = options;

  if (!useGlobalSettings && !forceCurrency) {
    return { ...data };
  }

  const originalLocaleSettings = getRegionalData(data);
  const modifiedLocaleSettings = {
    ...originalLocaleSettings,
    ...(useGlobalSettings && {
      isGlobalFlagEnabled: GLOBAL_SETTINGS_DEFAULTS.isGlobalFlagEnabled,
      entityName: GLOBAL_SETTINGS_DEFAULTS.entityName,
      region: GLOBAL_SETTINGS_DEFAULTS.region,
    }),
    ...(forceCurrency && {
      userCurrency: forceCurrency,
      currency: GLOBAL_SETTINGS_DEFAULTS.currency,
    }),
  };

  return {
    ...data,
    localeSettings: modifiedLocaleSettings,
    ...(forceCurrency && { [USER_CURRENCY]: forceCurrency }),
  };
};

/**
 * Parses date key from fare calendar format (DDMMYY) to formatted date string
 * @param {string} dateKey - Date in DDMMYY format
 * @returns {string} Formatted date in DD/MM/YYYY format
 */
const parseFareDateKey = (dateKey) => {
  const day = dateKey.slice(0, 2);
  const month = dateKey.slice(2, 4);
  const year = `20${dateKey.slice(4, 6)}`;
  return convertDateFormat(`${day}${month}${year}`, "DDMMYYYY", "DD/MM/YYYY");
};

/**
 * Filters fares to include only valid entries with fare and airline info
 * @param {Object} fares - Raw fares object from API
 * @returns {Object} Filtered fares object
 */
const filterValidFares = (fares = {}) =>
  Object.fromEntries(
    Object.entries(fares).filter(
      ([_, value]) =>
        value?.fr && value?.airlineInfo && Object.keys(value.airlineInfo).length > 0,
    ),
  );

/**
 * Builds a route map entry from fare data
 * @param {Object} fareValue - Single fare entry from API
 * @param {string} dateKey - Date key in DDMMYY format
 * @param {string} airlineIconUrl - URL of airline icon
 * @param {string} userCurrency - User's currency code
 * @returns {Object} Route map entry
 */
const buildRouteMapEntry = (fareValue, dateKey, airlineIconUrl, userCurrency) => {
  const fareStr = fareValue.fr;
  const { name = "", codes = [] } = fareValue.airlineInfo || {};

  return {
    cf: fareStr,
    cur: fareValue.cur || userCurrency.toUpperCase(),
    cheapestFare: Number(fareStr?.replace(/,/g, "")),
    airlineCode: codes[0],
    airlineName: name,
    airlineIconUrl,
    airline_cheapest_date: parseFareDateKey(dateKey),
  };
};

/**
 * Fetches fare calendar data from API
 * @param {string} apiUrl - API URL to fetch from
 * @param {Object} fetchOptions - Fetch options including headers
 * @returns {Promise<Object>} Fare calendar data or empty object on error
 */
const fetchFareCalendarData = async (apiUrl, fetchOptions) => {
  if (!apiUrl) return {};

  try {
    const response = await fetch(apiUrl, fetchOptions);
    return await response.json();
  } catch (error) {
    return {};
  }
};

/**
 * Processes a single route from cache hit
 * @param {Object} cacheData - Cached route data
 * @param {string} cacheKey - Cache key for the route
 * @param {Object} tracker - Object tracking cheapest routes and fares
 */
const processRouteFromCache = (cacheData, cacheKey, tracker) => {
  if (cacheData.error) return;

  tracker.cheapestRoutes[cacheKey] = cacheData;
  const fare = cacheData?.cheapestFare;

  if (fare < tracker.cheapestFare) {
    tracker.cheapestFare = fare;
    tracker.cheapestKey = cacheKey;
    tracker.airline = cacheData.airlineCode;
  }
  tracker.airlineIconUrl = cacheData.airlineIconUrl;
};

/**
 * Processes fares from API response and updates tracker
 * @param {Object} fares - Filtered fares object
 * @param {string} airlineCode - Optional airline code filter
 * @param {string} currentRouteAirlineIconUrl - Icon URL from current route
 * @param {string} cacheKey - Cache key for the route
 * @param {string} userCurrency - User's currency code
 * @param {Object} tracker - Object tracking cheapest routes and fares
 * @returns {Object|null} Route map entry if found, null otherwise
 */
const processFaresFromApi = (
  fares,
  airlineCode,
  currentRouteAirlineIconUrl,
  cacheKey,
  userCurrency,
  tracker,
) => {
  let cheapRouteMap = null;
  let currentCheapestFare = Number.MAX_VALUE;

  Object.entries(fares).forEach(([dateKey, fareValue]) => {
    const fareStr = fareValue.fr;
    const fare = Number(fareStr?.replace(/,/g, ""));
    const { codes = [] } = fareValue.airlineInfo || {};

    // Skip if airline filter is set and doesn't match
    if (airlineCode && !codes.includes(airlineCode)) return;

    // Update global cheapest
    if (fare < tracker.cheapestFare) {
      tracker.cheapestFare = fare;
      tracker.cheapestKey = cacheKey;
      tracker.airlineIconUrl = currentRouteAirlineIconUrl;
    }

    // Update route cheapest
    if (fare < currentCheapestFare) {
      currentCheapestFare = fare;
      cheapRouteMap = buildRouteMapEntry(fareValue, dateKey, currentRouteAirlineIconUrl, userCurrency);
      tracker.airline = codes[0];
      tracker.cheapestRoutes[cacheKey] = cheapRouteMap;
    }
  });

  return cheapRouteMap;
};

/**
 * Processes a single route from API (cache miss)
 * @param {string} cacheKey - Cache key for the route
 * @param {string} routeKey - Route key (src-dest)
 * @param {string} airlineCode - Optional airline code filter
 * @param {Object} dataMap - Data map with configuration
 * @param {Object} tracker - Object tracking cheapest routes and fares
 * @returns {Promise<Object>} Updated dataMap
 */
const processRouteFromApi = async (cacheKey, routeKey, airlineCode, dataMap, tracker) => {
  const responseObject = getFareCalendarApiAndHeader(dataMap, routeKey) || {};
  let { apiUrl } = responseObject;
  const { options: fetchOptions, dataMap: updatedDataMap } = responseObject;

  if (airlineCode) {
    apiUrl += `&airlineFilter=${airlineCode}`;
  }

  const fareCalendarData = await fetchFareCalendarData(apiUrl, fetchOptions);

  if (!fareCalendarData || Object.keys(fareCalendarData).length === 0) {
    await CacheMaster.setCache(cacheKey, NO_DATA_ERROR, FARE_CACHE_TTL_SECONDS);
    return updatedDataMap;
  }

  const { fares = {}, airlineIconUrl: currentRouteAirlineIconUrl } = fareCalendarData;
  const validFares = filterValidFares(fares);

  const cheapRouteMap = processFaresFromApi(
    validFares,
    airlineCode,
    currentRouteAirlineIconUrl,
    cacheKey,
    updatedDataMap[USER_CURRENCY],
    tracker,
  );

  // Cache the result
  const cacheValue = cheapRouteMap || NO_DATA_ERROR;
  await CacheMaster.setCache(cacheKey, cacheValue, FARE_CACHE_TTL_SECONDS);

  return updatedDataMap;
};

/**
 * Fetches all cache entries in parallel for the given keys.
 * @param {string[]} keys - Array of cache keys to fetch
 * @returns {Promise<Array<{cacheKey: string, cacheData: Object|null}>>}
 */
const fetchAllCacheEntries = async (keys) => {
  return Promise.all(
    keys.map(async (cacheKey) => ({
      cacheKey,
      cacheData: await CacheMaster.getCache(cacheKey),
    })),
  );
};

/**
 * Categorizes cache results into hits and misses.
 * @param {Array<{cacheKey: string, cacheData: Object|null}>} cacheEntries - Cache lookup results
 * @param {string[]} routeKeys - Route keys corresponding to cache keys
 * @returns {{cacheHits: Array, cacheMisses: Array}}
 */
const categorizeCacheResults = (cacheEntries, routeKeys) => {
  const cacheHits = [];
  const cacheMisses = [];

  cacheEntries.forEach((entry, index) => {
    if (entry.cacheData) {
      cacheHits.push(entry);
    } else {
      cacheMisses.push({
        cacheKey: entry.cacheKey,
        routeKey: routeKeys[index],
      });
    }
  });

  return { cacheHits, cacheMisses };
};

/**
 * Fetches API data for all cache misses in parallel.
 * @param {Array<{cacheKey: string, routeKey: string}>} cacheMisses - Routes that need API calls
 * @param {string|null} airlineCode - Airline code filter
 * @param {Object} dataMap - Data map with configuration
 * @param {Object} tracker - Tracker object for accumulating results
 * @returns {Promise<void>}
 */
const fetchAllApiData = async (cacheMisses, airlineCode, dataMap, tracker) => {
  await Promise.all(
    cacheMisses.map(({ cacheKey, routeKey }) =>
      processRouteFromApi(cacheKey, routeKey, airlineCode, dataMap, tracker),
    ),
  );
};

/**
 * Fetches cheapest routes with fare and date information, utilizing cache when available.
 * Follows cache-aside pattern: check cache first, fallback to API, then cache result.
 *
 * @param {string[]} keys - Array of cache keys for routes
 * @param {string|null} airlineCode - Optional airline code to filter results
 * @param {string[]} routeKeys - Array of route keys (src-dest format)
 * @param {Object} data - Data map with configuration and tokens
 * @param {Object} options - Additional options
 * @param {boolean} options.useGlobalSettings - Whether to use global settings
 * @param {string|null} options.forceCurrency - Currency to force for all requests
 * @returns {Promise<Object|null>} Object containing cheapestRoutes, cheapestKey, and airlineIconUrl
 */
export const getCheapestRoutesFareAndDateWithTokensFromCache = async (
  keys = [],
  airlineCode,
  routeKeys,
  data,
  options = {},
) => {
  try {
    let dataMap = { ...data };
    dataMap = applyLocaleOverrides(data, options);

    // Tracker object to maintain state across iterations (avoids mutation of multiple variables)
    const tracker = {
      airline: "",
      cheapestKey: "",
      cheapestRoutes: {},
      airlineIconUrl: "",
      cheapestFare: Number.MAX_VALUE,
    };

    // Phase 1: Fetch all cache entries in parallel
    const cacheEntries = await fetchAllCacheEntries(keys);

    // Phase 2: Categorize into hits and misses
    const { cacheHits, cacheMisses } = categorizeCacheResults(cacheEntries, routeKeys);

    // Phase 3: Process cache hits synchronously (fast operations)
    cacheHits.forEach(({ cacheKey, cacheData }) => {
      processRouteFromCache(cacheData, cacheKey, tracker);
    });

    // Phase 4: Fetch API data for cache misses in parallel
    if (cacheMisses.length > 0) {
      await fetchAllApiData(cacheMisses, airlineCode, dataMap, tracker);
    }

    return {
      cheapestRoutes: tracker.cheapestRoutes,
      cheapestKey: tracker.cheapestKey,
      airlineIconUrl: tracker.airlineIconUrl,
    };
  } catch (error) {
    console.error("errorGetCheapestRoutesFareAndDateWithTokensFromCache", error);
    return null;
  }
};

export const addAirlineDetailsAndUrlToResponseMap = (
  data = {},
  responseMap,
  routeMap,
  airlineIconUrl,
) => {
  const dataMap = { ...data };
  const cheapestRoutes = [];
  const { currentDomainName, isGoibibo } = dataMap;
  let map = {};
  try {
    if (responseMap) {
      for (const [key, value] of Object.entries(responseMap)) {
        try {
          map = responseMap[key];
          const routeMapValue = routeMap[key];
          map = { ...map, ...routeMapValue };
        } catch (error) {
          console.error("errorCreatingRouteMapAddAirlineDetailsAndUrlToResponseMap", error);
        }
        map.airline_logo = airlineIconUrl
          ? airlineIconUrl.replace(/{airline}/g, value.airlineCode)
          : "";
        map.airline_name = value.airlineName ? value.airlineName.split(",")[0] : "";
        map.airline_code = value.airlineCode;
        if (dataMap[LANGUAGE] && dataMap[LANGUAGE] === "hi") {
          map.airline_hi_name = value.airlineName.split(",")[0];
        }
        map.url = `https://${
          dataMap?.isGoibibo ? "www.goibibo.com" : currentDomainName
        }/flight/search?tripType=O&itinerary=${map[TOKEN_SRC_CITY_CODE]}-${
          map[TOKEN_DES_CITY_CODE]
        }-${map[TOKEN_AIRLINE_CHEAPEST_FARE_DATE]}&paxType=A-1_C-0_I-0&cabinClass=E&intl=${
          dataMap[IS_INTL] || false
        }&ccde=${dataMap.ccde || IN}&lang=${dataMap[LANG] || eng}${
          isGoibibo ? "&cmpid=SEO" : "&cmp=SEO"
        }`;
        cheapestRoutes.push(map);
      }
    }
    try {
      cheapestRoutes.sort((route1, route2) => route1.cheapestFare - route2.cheapestFare);
    } catch (error) {
      console.error("errorSortingCheapestRoutes", error);
    }
  } catch (error) {
    console.error("errorAddAirlineDetailsAndUrlToResponseMap", error);
  }
  return cheapestRoutes;
};

export const setTokensFromResponse = (data, cheapestRouteMap) => {
  const dataMap = { ...data };
  if (cheapestRouteMap && Object.keys(cheapestRouteMap).length > 0) {
    try {
      const tokenData = dataMap[TOKENS] || {};
      tokenData[TOKEN_AIRLINE_CHEAPEST_PRICE] = cheapestRouteMap.cf;
      tokenData[TOKEN_AIRLINE_CHEAPEST_ROUTE_SRC] = cheapestRouteMap[TOKEN_SRC_CITY_NAME];
      tokenData[TOKEN_AIRLINE_CHEAPEST_ROUTE_DEST] = cheapestRouteMap[TOKEN_DES_CITY_NAME];
      tokenData[TOKEN_AIRLINE_CHEAPEST_FARE_DATE] = convertDateFormat(
        cheapestRouteMap[TOKEN_AIRLINE_CHEAPEST_FARE_DATE],
        "DD/MM/YYYY",
        "DD MMM YYYY",
      );
      dataMap.tokens = { ...tokenData };
    } catch (error) {
      console.error("errorSettingTokensFromResponse", error);
    }
  }
  return dataMap;
};

export const checkIsBot = (userAgent) => {
  if (userAgent) {
    return isbot(userAgent) || userAgent.includes("Google-InspectionTool");
  }
  return false;
};

export const wrapToGiListBLock = (html) => {
  try {
    let domHtml = parse(html);
    const h3Node = domHtml.querySelector("h3");
    const allLinks = domHtml.querySelectorAll("div > div > a");
    let finalHtml = `<div class="content_blocks">${h3Node.toString()}<div class="fli-sectionbox padd0">${allLinks
      .map((div) => `<div class="rowBlock">${div.toString()}</div>`)
      .join("")}</div></div>`;
    return finalHtml;
  } catch (e) {}
  return html;
};

export const wrapToGiListBLock2 = (html) => {
  try {
    let domHtml = parse(html);
    const h3Node = domHtml.querySelector(".head");
    const allLinks = domHtml.querySelectorAll(".CityLinksWrp > div > a");
    let finalHtml = `<div class="content_blocks"><h3>${
      h3Node.innerHTML
    }</h3><div class="fli-sectionbox padd0">${allLinks
      .map((aTag) => `<div class="rowBlock">${aTag.toString()}</div>`)
      .join("")}</div></div>`;
    return finalHtml;
  } catch (e) {
    console.error("errorWrapToGiListBLock2", e);
  }
  return html;
};

export const wrapToGiContentBlock = (html) => {
  try {
    let finalHtml = `<div class="content_blocks"><div class="fli-sectionbox">${html}</div></div>`;
    return finalHtml;
  } catch (e) {}
  return html;
};

export const getBaseUrlForCreatingSiteMap = (countryUrlPhrase, country_code) => {
  // UAE - United Arab Emirates
  if (country_code === "AE" || countryUrlPhrase === "united_arab_emirates") {
    return "ae.makemytrip.global";
  }

  // Saudi Arabia
  if (country_code === "SA" || countryUrlPhrase === "saudi_arabia") {
    return "sa.makemytrip.global";
  }

  // India
  if (country_code === "IN" || countryUrlPhrase === "india") {
    return "www.makemytrip.com";
  }

  // Any other country with either parameter present
  if (countryUrlPhrase || country_code) {
    return "www.makemytrip.global";
  }

  // Default fallback
  return "www.makemytrip.com";
};

export const checkForCorrectUrl = async (context, isIntl, currentDomainName, isGoibibo) => {
  const { req, res, resolvedUrl } = context || {};
  const param = context?.params?.param || [];
  const section = resolvedUrl.startsWith("/international-flights")
    ? "international-flights"
    : "flights";

  // Step 1: Sanitize: decode + trim + remove empty/spacey segments
  const sanitizedParams = param.map((p) => decodeURIComponent(p).trim()).filter(Boolean);
  const originalPath = param.join("/");
  const cleanedPath = sanitizedParams.join("/");

  // Check for embedded full URLs within path segments
  const hasEmbeddedUrl = sanitizedParams.some(
    (param) =>
      param.includes("http:/") || param.includes("https:/") || param.includes("makemytrip"),
  );

  if (hasEmbeddedUrl) {
    // Determine redirect destination based on isIntl and global flow
    const isGlobal = isGlobalFlow(req);
    let redirectDestination;

    if (isIntl && !isGlobal) {
      redirectDestination = "/international-flights";
    } else {
      redirectDestination = "/flights";
    }

    return {
      redirect: {
        destination: redirectDestination,
        statusCode: 301,
      },
    };
  }

  // Step 3: If sanitized differs, redirect to cleaned
  if (originalPath !== cleanedPath) {
    return {
      redirect: {
        destination: `/${section}/${cleanedPath}`,
        statusCode: 301,
      },
    };
  }
  if (isGoibibo) {
    return {};
  }
  const localeSettings = req.localeSettings;
  const userAgent = req.headers["user-agent"] || "";
  const isBot = checkIsBot(userAgent);
  const shouldRedirect = await redirection({
    req,
    res,
    sanitizedParams,
    currentDomainName,
    isIntl,
    localeSettings,
    isBot,
  });
  if (shouldRedirect) {
    return shouldRedirect;
  }
  return {};
};

export function executeScriptString(htmlString, isGoibibo = false) {
  if (!document || !document.body) {
    console.warn("executeScriptString: Document body not available");
    return;
  }

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  const scripts = tempDiv.querySelectorAll("script");

  if (scripts.length === 0) {
    if (htmlString.includes("document.write")) {
      console.warn("executeScriptString: Skipping inline script with document.write");
      return;
    }

    const newScript = document.createElement("script");
    newScript.textContent = transformDOMContentLoaded(htmlString);
    document.body.appendChild(newScript);

    if (!isGoibibo) {
      try {
        eval(newScript.textContent);
      } catch (error) {
        console.warn("executeScriptString: Error executing script", error);
      }
    }
  } else {
    const executeScriptSequentially = (index) => {
      if (index >= scripts.length) {
        // All scripts executed, append non-script content
        Array.from(tempDiv.childNodes).forEach((node) => {
          if (node.tagName !== "SCRIPT") {
            document.body.appendChild(node.cloneNode(true));
          }
        });
        return;
      }

      const oldScript = scripts[index];
      const scriptContent = oldScript.textContent || "";

      const newScript = document.createElement("script");
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }

      if (oldScript.src) {
        newScript.src = oldScript.src;
        newScript.onload = () => executeScriptSequentially(index + 1);
        newScript.onerror = () => executeScriptSequentially(index + 1);
        document.body.appendChild(newScript);
      } else {
        const transformedCode = transformDOMContentLoaded(scriptContent);
        newScript.textContent = transformedCode;
        document.body.appendChild(newScript);
        if (!isGoibibo) {
          try {
            eval(transformedCode);
          } catch (error) {
            console.warn("executeScriptString: Error executing inline script", error);
          }
        }
        executeScriptSequentially(index + 1);
      }
    };

    executeScriptSequentially(0);
  }

  // Helper to convert DOMContentLoaded handler to immediate code if DOM already loaded
  function transformDOMContentLoaded(code) {
    const domReady = document.readyState === "interactive" || document.readyState === "complete";

    if (
      (code.includes('window.addEventListener("DOMContentLoaded"') ||
        code.includes("window.addEventListener('DOMContentLoaded'")) &&
      domReady
    ) {
      try {
        const match = code.match(
          /window\.addEventListener\(["']DOMContentLoaded["'],\s*function\s*\(\)\s*{([\s\S]*?)}\s*\)/,
        );
        if (match && match[1]) {
          return match[1]; // Return only the function body
        }
      } catch (e) {
        console.warn("executeScriptString: Failed to transform DOMContentLoaded");
      }
    }

    return code;
  }
}

export const getDestPartsForAirlineSchedule = async (data = {}) => {
  let dataMap = { ...data };
  const { isIntl = false } = dataMap;
  const destPart = dataMap?.destPart;

  if (!destPart) {
    return dataMap;
  }

  try {
    // Remove the "-airline-schedule/" or "-airline-schedule" suffix
    let cleanedString = destPart;
    if (cleanedString.endsWith("-airline-schedule/")) {
      cleanedString = cleanedString.slice(0, -18); // Remove "-airline-schedule/"
    } else if (cleanedString.endsWith("-airline-schedule")) {
      cleanedString = cleanedString.slice(0, -17); // Remove "-airline-schedule"
    } else {
      // If the pattern doesn't match, return early
      return dataMap;
    }

    // Split the cleaned string by "-"
    const parts = cleanedString.split("-");

    if (parts.length < 2) {
      return dataMap;
    }

    let cityPart = "";
    let airlinePart = "";
    let airlineData = null;
    let cityData = null;

    // Go from right to left to find valid airline
    for (let i = parts.length - 1; i >= 1; i--) {
      // Build potential airline string from position i to end
      const potentialAirline = parts.slice(i).join("-");
      // Build potential city string from start to position i-1
      const potentialCity = parts.slice(0, i).join("-");

      // Check if current string is valid airline using getGIAirlineByUrlPhrase
      try {
        airlineData = await getGIAirlineByUrlPhrase(potentialAirline);

        if (airlineData) {
          // Found valid airline, set the parts
          airlinePart = potentialAirline;
          cityPart = potentialCity;

          // Try to get city data as well
          cityData = await getGICityByFlightsUrlPhrase(potentialCity);
          // Break the loop since we found a valid split
          break;
        }
      } catch (error) {
        // Continue to next iteration if getGIAirlineByUrlPhrase fails
        console.warn(`Error checking airline: ${potentialAirline}`, error);
        continue;
      }
    }

    // Add extracted data to dataMap
    if (cityPart && airlinePart) {
      dataMap.dest_url_phrase = cityPart;
      dataMap.airline_url_phrase = airlinePart;

      if (cityData && isIntl) {
        dataMap[IF_DEST_CITY] = cityData;
      } else {
        dataMap[DEST_CITY] = cityData;
      }

      if (airlineData && isIntl) {
        dataMap[INTL_AIRLINE] = airlineData;
      } else {
        dataMap[AIRLINE] = airlineData;
      }
    }
  } catch (error) {
    console.error("Error extracting city and airline from destPart:", error);
  }

  return dataMap;
};
